import { Box, Card } from "@mui/material";
import ErrorAlert from "../../toolkit/ErrorAlert";
import baseTheme from "../../themes/baseTheme";

const { palette } = baseTheme;

export default function ResultsGridView({
  headers = [],
  rows = [],
  GridItem,
  ...props
}) {
  if (!GridItem) {
    return (
      <ErrorAlert
        severity="error"
        message="GridItemComponent not provided to CollectionsTemplate"
      />
    );
  }
  return (
    // <Box
    //   sx={{
    //     gap: "0.6rem",
    //     padding: "0.6rem",
    //     "@media (min-width: 600px)": {
    //       display: "flex",
    //       flexWrap: "wrap",
    //       gap: "0.6rem",
    //     },
    //   }}
    // >
    //   {rows.map((row, i) => (
    //     <Card
    //       key={`${row.key}`}
    //       className="grid-card"
    //       sx={{
    //         display: "inline-flex",
    //         padding: "0.8rem",
    //         marginBottom: "0.6rem",
    //         borderRadius: 0.25,
    //         width:"24%",
    //         boxShadow: "none",
    //         border: `solid 1px ${palette.grey[30]}`,
    //         backgroundColor: palette.grey[0],
    //         width: "100%",
    //         "@media (min-width: 600px)": {
    //           width: "calc(50% - 0.5rem)",
    //           marginBottom: 0,
    //         },
    //         "@media (min-width: 900px)": {
    //           width: "calc(33% - 0.5rem)",
    //         },
    //         "@media (min-width: 1200px)": {
    //           width: "calc(25% - 0.5rem)",
    //         },
    //       }}
    //     >
    //       <GridItem key={i} headers={headers} {...row} {...props} />
    //     </Card>
    //   ))}
    // </Box>
    <Box
      sx={{
        display: "grid",
        gap: "0.6rem",
        padding: "0.6rem",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(4, 1fr)",
        },
      }}
    >
      {rows.map((row, i) => (
        <Card
          key={row.key}
          sx={{
            p: 1,
            borderRadius: 0.25,
            boxShadow: "none",
            border: `1px solid ${palette.grey[30]}`,
            backgroundColor: palette.grey[0],
          }}
        >
          <GridItem key={i} headers={headers} {...row} {...props} />
        </Card>
      ))}
    </Box>
  );
}
